// This file is auto-generated. Do not edit!

export default [
  {
    name: "50wstETH-50ACX",
    id: "60",
    bpt: "0x36Be1E97eA98AB43b4dEBf92742517266F5731a3",
    tokens: [
      {
        address: "0x44108f0223A3C3028F5Fe7AEC7f9bb2E66beF82F",
        symbol: "ACX",
      },
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
    ],
    rewarder: "0x55BFBb2a8De4D7001C5542d19C702433252C904b",
  },
  {
    name: "50PENDLE-50WETH",
    id: "61",
    bpt: "0xFD1Cf6FD41F229Ca86ada0584c63C49C3d66BbC9",
    tokens: [
      {
        address: "0x808507121B80c02388fAd14726482e061B8da827",
        symbol: "PENDLE",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
    rewarder: "0x08129a472dfb92A1596Bbe31f27c53914a990563",
  },
  {
    name: "20WETH-80ALCX",
    id: "74",
    bpt: "0xf16aEe6a71aF1A9Bc8F56975A4c2705ca7A782Bc",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xdBdb4d16EdA451D0503b854CF79D55697F90c8DF",
        symbol: "ALCX",
      },
    ],
    rewarder: "0x8B227E3D50117E80a02cd0c67Cd6F89A8b7B46d7",
  },
  {
    name: "B-wjAura-wETH",
    id: "82",
    bpt: "0x68e3266C9C8bbD44ad9Dca5AFBfe629022AeE9fE",
    tokens: [
      {
        address: "0x198d7387Fa97A73F05b8578CdEFf8F2A1f34Cd1F",
        symbol: "wjAURA",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
    rewarder: "0x0583A75B3D91020E9Db90301Ded0A2676e55d1c0",
  },
  {
    name: "50COIL-50USDC",
    id: "95",
    bpt: "0x42FBD9F666AaCC0026ca1B88C94259519e03dd67",
    tokens: [
      {
        address: "0x823E1B82cE1Dc147Bbdb25a203f046aFab1CE918",
        symbol: "COIL",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
    rewarder: "0x6f6801b49B5D8CA2Ea5FEAD9096F347B9355a330",
  },
  {
    name: "50WETH-50AURA",
    id: "100",
    bpt: "0xCfCA23cA9CA720B6E98E3Eb9B6aa0fFC4a5C08B9",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xC0c293ce456fF0ED870ADd98a0828Dd4d2903DBF",
        symbol: "AURA",
      },
    ],
    rewarder: "0x1204f5060bE8b716F5A62b4Df4cE32acD01a69f5",
  },
  {
    name: "B-auraBAL-STABLE",
    id: "101",
    bpt: "0x3dd0843A028C86e0b760b1A76929d1C5Ef93a2dd",
    tokens: [
      {
        address: "0x5c6Ee304399DBdB9C8Ef030aB642B10820DB8F56",
        symbol: "B-80BAL-20WETH",
      },
      {
        address: "0x616e8BfA43F920657B3497DBf40D6b1A02D4608d",
        symbol: "auraBAL",
      },
    ],
    rewarder: "0x89D3D732da8bf0f88659Cf3738E5E44e553f9ED7",
  },
  {
    name: "50COW-50GNO",
    id: "104",
    bpt: "0x92762B42A06dCDDDc5B7362Cfb01E631c4D44B40",
    tokens: [
      {
        address: "0x6810e776880C02933D47DB1b9fc05908e5386b96",
        symbol: "GNO",
      },
      {
        address: "0xDEf1CA1fb7FBcDC777520aa7f396b4E015F497aB",
        symbol: "COW",
      },
    ],
    rewarder: "0x82FeB430d9D14eE5E635C41807e03fD8F5FfFDeC",
  },
  {
    name: "50COW-50WETH",
    id: "105",
    bpt: "0xde8C195Aa41C11a0c4787372deFBbDdAa31306D2",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xDEf1CA1fb7FBcDC777520aa7f396b4E015F497aB",
        symbol: "COW",
      },
    ],
    rewarder: "0xA6e54eA1C67396Bde9e92cA462197bE59Af3E875",
  },
  {
    name: "B-rETH-STABLE",
    id: "109",
    bpt: "0x1E19CF2D73a72Ef1332C882F20534B6519Be0276",
    tokens: [
      {
        address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
        symbol: "rETH",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
    rewarder: "0xDd1fE5AD401D4777cE89959b7fa587e569Bf125D",
  },
  {
    name: "20WETH-80WNCG",
    id: "110",
    bpt: "0xe8cc7E765647625B95F59C15848379D10B9AB4af",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xf203Ca1769ca8e9e8FE1DA9D147DB68B6c919817",
        symbol: "WNCG",
      },
    ],
    rewarder: "0x1E356C39CAAC89Da64A7f50b47564ca52C8cACA9",
  },
  {
    name: "B-80GNO-20WETH",
    id: "116",
    bpt: "0xF4C0DD9B82DA36C07605df83c8a416F11724d88b",
    tokens: [
      {
        address: "0x6810e776880C02933D47DB1b9fc05908e5386b96",
        symbol: "GNO",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
    rewarder: "0x971fAF6BE8C20f53fe3acF065fe6E14FBA0b8a9a",
  },
  {
    name: "20WETH-80T",
    id: "119",
    bpt: "0x8167A1117691f39e05e9131cfA88F0e3A620E967",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
        symbol: "T",
      },
    ],
    rewarder: "0x77E20717a5a77893D1a94BbebC5f990b957062A7",
  },
  {
    name: "wstETH-WETH-BPT",
    id: "153",
    bpt: "0x93d199263632a4EF4Bb438F1feB99e57b4b5f0BD",
    tokens: [
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
    rewarder: "0x2a14dB8D09dB0542f6A371c0cB308A768227D67D",
  },
  {
    name: "STG/USDC",
    id: "154",
    bpt: "0x3ff3a210e57cFe679D9AD1e9bA6453A716C56a2e",
    tokens: [
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xAf5191B0De278C7286d6C7CC6ab6BB8A73bA2Cd6",
        symbol: "STG",
      },
    ],
    rewarder: "0x8bd520Bf5d59F959b25EE7b78811142dDe543134",
  },
  {
    name: "GHO/USDT/USDC",
    id: "157",
    bpt: "0x8353157092ED8Be69a9DF8F95af097bbF33Cb2aF",
    tokens: [
      {
        address: "0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f",
        symbol: "GHO",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "USDT",
      },
    ],
    rewarder: "0xBDD6984C3179B099E9D383ee2F44F3A57764BF7d",
  },
  {
    name: "2BTC",
    id: "159",
    bpt: "0xe4e72f872c4048925a78E1e6Fddac411C9ae348A",
    tokens: [
      {
        address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
        symbol: "tBTC",
      },
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
    ],
    rewarder: "0xb3c8cC0f433200C3a92664A5fEa626eD077e9D39",
  },
  {
    name: "RDNT-WETH",
    id: "171",
    bpt: "0xcF7b51ce5755513d4bE016b0e28D6EDEffa1d52a",
    tokens: [
      {
        address: "0x137dDB47Ee24EaA998a535Ab00378d6BFa84F893",
        symbol: "RDNT",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
    rewarder: "0x61F205f1236c4E6D3f73618BB6250d5A9cC5B8bb",
  },
  {
    name: "ECLP-GYD-sDAI",
    id: "176",
    bpt: "0x1CCE5169bDe03f3d5aD0206f6BD057953539DAE6",
    tokens: [
      {
        address: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
        symbol: "sDAI",
      },
      {
        address: "0xe07F9D810a48ab5c3c914BA3cA53AF14E4491e8A",
        symbol: "GYD",
      },
    ],
    rewarder: "0x2C0D60f986cDe7eE59489055aa22A8E49b6825aD",
  },
  {
    name: "ECLP-GYD-USDT",
    id: "177",
    bpt: "0xfbfaD5fa9E99081da6461F36f229B5cC88A64c63",
    tokens: [
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "USDT",
      },
      {
        address: "0xe07F9D810a48ab5c3c914BA3cA53AF14E4491e8A",
        symbol: "GYD",
      },
    ],
    rewarder: "0x4313428170c09ca81117a95f0418aefE3446d935",
  },
  {
    name: "osETH/wETH-BPT",
    id: "179",
    bpt: "0xDACf5Fa19b1f720111609043ac67A9818262850c",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xf1C9acDc66974dFB6dEcB12aA385b9cD01190E38",
        symbol: "osETH",
      },
    ],
    rewarder: "0x5F032f15B4e910252EDaDdB899f7201E89C8cD6b",
  },
  {
    name: "80MIMO-20WETH",
    id: "180",
    bpt: "0xee3959FD00a0B996d801fc34B7CE566bD037f5f5",
    tokens: [
      {
        address: "0x90B831fa3Bebf58E9744A14D638E25B4eE06f9Bc",
        symbol: "MIMO",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
    rewarder: "0x098DCC73cd97C2BE5eAC5bD59c50cc034b60C06E",
  },
  {
    name: "weETH/rETH",
    id: "182",
    bpt: "0x05ff47AFADa98a98982113758878F9A8B9FddA0a",
    tokens: [
      {
        address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
        symbol: "rETH",
      },
      {
        address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
        symbol: "weETH",
      },
    ],
    rewarder: "0x07A319A023859BbD49CC9C38ee891c3EA9283Cc5",
  },
  {
    name: "pxETH/wETH",
    id: "185",
    bpt: "0x88794C65550DeB6b4087B7552eCf295113794410",
    tokens: [
      {
        address: "0x04C154b66CB340F3Ae24111CC767e0184Ed00Cc6",
        symbol: "pxETH",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
    rewarder: "0x570eA5C8A528E3495EE9883910012BeD598E8814",
  },
  {
    name: "80T-20TBTC",
    id: "188",
    bpt: "0x6228f64D5BA8376652Bfe7E36569D595347cF6Fb",
    tokens: [
      {
        address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
        symbol: "tBTC",
      },
      {
        address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
        symbol: "T",
      },
    ],
    rewarder: "0x8660F02Ca94970C45add17CEDdCC81DD4D90ffED",
  },
  {
    name: "ETHx/wstETH",
    id: "207",
    bpt: "0xB91159aa527D4769CB9FAf3e4ADB760c7E8C8Ea7",
    tokens: [
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xA35b1B31Ce002FBF2058D22F30f95D405200A15b",
        symbol: "ETHx",
      },
    ],
    rewarder: "0x571a20C14a7c3Ac6d30Ee7D1925940bb0C027696",
  },
  {
    name: "ECLP-paUSD-GYD",
    id: "210",
    bpt: "0xae2D97CbBc13B67988ECEd2abA0F6939655eD3De",
    tokens: [
      {
        address: "0x571f54D23cDf2211C83E9A0CbD92AcA36c48Fa02",
        symbol: "paUSD",
      },
      {
        address: "0xe07F9D810a48ab5c3c914BA3cA53AF14E4491e8A",
        symbol: "GYD",
      },
    ],
    rewarder: "0x01B8209e20B999eE3271A880fA0Ef17cd3eFB1F6",
  },
  {
    name: "ECLP-PAR-EURA",
    id: "211",
    bpt: "0x2044aFEF1268100918F88De66a3532Eab3D8f3ef",
    tokens: [
      {
        address: "0x1a7e4e63778B4f12a199C062f3eFdD288afCBce8",
        symbol: "EURA",
      },
      {
        address: "0x68037790A0229e9Ce6EaA8A99ea92964106C4703",
        symbol: "PAR",
      },
    ],
    rewarder: "0xdB745558A1b71E5C355aF79c2E54118e753F5c83",
  },
  {
    name: "ECLP-stdeUSD-deUSD",
    id: "228",
    bpt: "0x41FDbea2E52790c0a1Dc374F07b628741f2E062D",
    tokens: [
      {
        address: "0x15700B564Ca08D9439C58cA5053166E8317aa138",
        symbol: "deUSD",
      },
      {
        address: "0x5C5b196aBE0d54485975D1Ec29617D42D9198326",
        symbol: "sdeUSD",
      },
    ],
    rewarder: "0x7405Bf405185391525Ab06fABcdFf51fdc656A46",
  },
  {
    name: "60GOLD-40WETH",
    id: "229",
    bpt: "0xcF8dFdb73e7434b05903B5599fB96174555F4353",
    tokens: [
      {
        address: "0x583019fF0f430721aDa9cfb4fac8F06cA104d0B4",
        symbol: "st-yETH",
      },
      {
        address: "0x9DeB0fc809955b79c85e82918E8586d3b7d2695a",
        symbol: "GOLD",
      },
    ],
    rewarder: "0xca5Ee20b1bF03EfBCfD28f01Cd2cAb4d0028E64c",
  },
  {
    name: "ECLP-sUSDe-GYD",
    id: "230",
    bpt: "0x8D93B853849b9884E2Bb413444Ec23eB5366eE91",
    tokens: [
      {
        address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
        symbol: "sUSDe",
      },
      {
        address: "0xe07F9D810a48ab5c3c914BA3cA53AF14E4491e8A",
        symbol: "GYD",
      },
    ],
    rewarder: "0x1F2B312C30B08C1957bd3ADA616E77BC7bFf51ff",
  },
  {
    name: "B-kaiAURA-AURA-WEIGHTED",
    id: "236",
    bpt: "0x62E57e37E3185871c13a422A363293780D17305B",
    tokens: [
      {
        address: "0xC0c293ce456fF0ED870ADd98a0828Dd4d2903DBF",
        symbol: "AURA",
      },
      {
        address: "0xFFd9c960bC303b8d3aAED58229ce8a7310bCc5b8",
        symbol: "kaiAURA",
      },
    ],
    rewarder: "0x2508F0f5230085c9A42f703012e453B56C037A92",
  },
  {
    name: "B-KAI-WETH-WEIGHTED",
    id: "238",
    bpt: "0x0AAba3D6a05a606b7A794877Dd0beFDa47474dB0",
    tokens: [
      {
        address: "0x63e5dC7C071C1F18d44b69bc86f4c80F24851388",
        symbol: "KAI",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
    rewarder: "0x3ab2BC49BacF9564EC0a2a8B06908CE3DAC90Af4",
  },
  {
    name: "B-sdBAL-STABLE",
    id: "249",
    bpt: "0x2d011aDf89f0576C9B722c28269FcB5D50C2d179",
    tokens: [
      {
        address: "0x5c6Ee304399DBdB9C8Ef030aB642B10820DB8F56",
        symbol: "B-80BAL-20WETH",
      },
      {
        address: "0xF24d8651578a55b0C119B9910759a351A3458895",
        symbol: "sdBal",
      },
    ],
    rewarder: "0xdb407aD592f0563250b55261c37e029152128f18",
  },
] as const
